import { cn } from "@/shared/lib/cn";
import { resolveLegacyUploadUrl } from "@/shared/lib/legacyAssets";
import { useState } from "react";

type EmployeeAvatarProps = {
  name: string;
  photo?: string | null;
  size?: number;
  className?: string;
  rounded?: "md" | "lg" | "full";
};

function getInitials(name: string): string {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
}

export function EmployeeAvatar({
  name,
  photo,
  size = 36,
  className,
  rounded = "md",
}: EmployeeAvatarProps) {
  const src = resolveLegacyUploadUrl(photo);
  const radius =
    rounded === "full" ? "rounded-full" : rounded === "lg" ? "rounded-lg" : "rounded-md";
  const [broken, setBroken] = useState(false);

  if (src && !broken) {
    return (
      <img
        src={src}
        alt={name}
        className={cn("shrink-0 object-cover", radius, className)}
        style={{ width: size, height: size }}
        onError={() => setBroken(true)}
      />
    );
  }

  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center bg-purple-soft text-xs font-semibold text-purple",
        radius,
        className,
      )}
      style={{ width: size, height: size, fontSize: Math.max(10, Math.round(size * 0.28)) }}
      aria-hidden
    >
      {getInitials(name)}
    </span>
  );
}
